import { Injectable } from '@angular/core';
import { RestClientService } from 'src/app/core/services/rest/rest-client.service';
import { Corporate } from '../model/corporate';

@Injectable({
    providedIn: 'root'
  })
  export class EntrepriseService{

    constructor(private _restClientService : RestClientService) 
    {}
    
    getAllCorporatesCustomersByWorkflow(workflow) 
    {
      return this._restClientService.load<Corporate[]>('entreprise/corporates-customers?workflow='+workflow);
    }
    
    getCorporateById(corporateId)
    {
        return this._restClientService.load<Corporate>('entreprise/corporate-by-id/'+corporateId);
    }
    
    putCorporate(corporate) 
    {
      return  this._restClientService.put<Corporate>(`entreprise/update-corporate`, corporate);
    }
    
    getCorporateByRequestId(requestId)
    {
      return this._restClientService.load<Corporate>('entreprise/corporate-by-requestid/'+requestId);
    }
    
    getCorporateByCodeClient(codeClient)
    {
      return this._restClientService.load<Corporate>('entreprise/corporate-by-codeclient/'+codeClient);
    }
    

}